// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3m-o0","icon":"SortAdornment_icon__1PmsQ","up":"SortAdornment_up__2Rds4","down":"SortAdornment_down__1dKjb","active":"SortAdornment_active__15mpn"};